import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import "./Theme.css";
import "./WFIRSSDetails.css";

const WFIRSSDetails = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const [scoreData, setScoreData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  useEffect(() => {
    lifestyleApi.fetchWFIRSSScore()
      .then((res) => setScoreData(res.data.data || null))
      .catch((err) => console.error("fetchWFIRSSScore:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="wfirss-loading">{t("common.loading")}</div>;

  return (
    <section className="wfirss-details-page">
      <div className="wfirss-total-card">
        <h2 className="wfirss-total-label">{t("wfirss.totalScore")}</h2>
        <h1 className="wfirss-total-val">{scoreData?.score ?? "--"}</h1>
      </div>
      {scoreData?.componentScore && (
        <div className="wfirss-domains">
          {Object.entries(scoreData.componentScore).map(([key, val]) => (
            <div key={key} className="wfirss-domain-row">
              <span className="wfirss-domain-label">{key}</span>
              <span className="wfirss-domain-val">{val}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default WFIRSSDetails;
